import { combineReducers } from 'redux';

import CustomerTypes from './types';

export const customerReducer = combineReducers({
  byEmail: CustomerTypes.byEmail.getReducer(),
  byId: CustomerTypes.byId.getReducer(),
  updateCustomer: CustomerTypes.updateCustomer.getReducer(),
  sendCustomerSurvey: CustomerTypes.sendCustomerSurvey.getReducer(),
  hasCoproductionGains: CustomerTypes.hasCoproductionGains.getReducer(),
});
